export const HodoConfig = {
  firebaseKey: 'BB-wTadF8XkPvbqf0popurYLgNUiqE18PzDtyZCSLZD_INwc7ajHz8LDY4UXDieERpG5dyXMnnqyaHsq-qOOUpY'
}
